import React from 'react';
import {
  StyleSheet, Text, View, Image,
} from 'react-native';
import QRCode from 'react-qr-code';
import { translate } from 'react-i18next';
import scaleImg from '../assets/images/scale.png';
import { getConfig } from '../config';
import Theme from '../theme';
import {
  isMobileWeb,
  UserDataConsumer,
} from '../utils';
import { defaultScale } from '../utils/scaling';
import { InstallAppButton } from '../auth/components';
import { isDesktop } from '../utils/ScreenSizes';
import { TranslateProp } from '../common-types';

interface IProps { t: TranslateProp }

const ContinueOnAppScreen: React.FC<IProps> = ({ t }) => {
  const getQRCodeLink = (): string => getConfig().appDownloadUrl;

  const renderFooter = () => {
    if (isMobileWeb()) {
      return (
        <View style={styles.footer}>
          <InstallAppButton
            t={t}
            useButtonStyle
            containerStyle={styles.footerButton}
          />
        </View>
      );
    }

    return (
      <View style={styles.QRContainer}>
        <Text style={[styles.formHeader, { paddingBottom: defaultScale(15) }]}>
          {t('scanQRToInstall')}
        </Text>
        <QRCode
          value={getQRCodeLink()}
          viewBox='0 0 192 192'
          size={192}
        />
      </View>
    );
  };

  const containerStyle = isDesktop() ? styles.desktopBottomContainer : styles.mobileBottomContainer;
  const headingStyle = isDesktop() ? styles.desktopHeading : styles.mobileHeading;

  return (
    <View style={{ flex: 1, height: '100%', backgroundColor: Theme.WHITE }}>
      <Text style={headingStyle}>{t('tracking:continueOnTheAppToUseScale')}</Text>
      <View style={[containerStyle, { flex: 1, justifyContent: 'center' }]}>
        <Image
          source={scaleImg}
          resizeMode='contain'
          style={{ width: '100%', height: defaultScale(200), alignSelf: 'center' }}
        />
      </View>
      {renderFooter()}
    </View>
  );
};

const styles = StyleSheet.create({
  formHeader: {
    ...Theme.textStyle.bodyCopyReg,
    paddingTop: defaultScale(20),
    textAlign: 'center',
  },
  QRContainer: {
    marginBottom: defaultScale(20),
    paddingVertical: defaultScale(10),
    alignItems: 'center',
  },
  mobileBottomContainer: {
    backgroundColor: Theme.WHITE,
    alignItems: 'center',
    padding: defaultScale(15),
  },
  mobileHeading: {
    ...Theme.textStyle.heading,
    color: Theme.BLACK,
    marginVertical: defaultScale(20),
    textAlign: 'center',
  },
  desktopBottomContainer: {
    backgroundColor: Theme.WHITE,
    alignItems: 'center',
    paddingTop: defaultScale(15),
  },
  desktopHeading: {
    ...Theme.textStyle.heading,
    marginBottom: defaultScale(20),
  },
  footer: {
    width: '100%',
    padding: defaultScale(15),
    backgroundColor: Theme.WHITE,
    justifyContent: 'flex-end',
  },
  footerButton: {
    width: '100%',
  },
});

export default translate('auth')(
  UserDataConsumer(ContinueOnAppScreen),
);
